<template>
  <div id="weather">

    <!-- HOURLY -->
    <div class="row">
      <div class="col-md-12">
        <div class="card" style="text-align:center;">
          <div class="card-body" v-if="weather.data">
            <p><strong>Current Temperature:</strong> {{ weather.data.message.currently.temperature | toInteger }}°F | <strong>Wind:</strong> {{ weather.data.message.currently.windSpeed }} mph | <strong>Gusting:</strong> {{ weather.data.message.currently.windGust }} mph</p>
            <div class="row">
              <div
                v-for="(hour, index) in weather.data.message.hourly.data"
                v-if="index > 0 && index < 8"
                class="col week-days"
              >
                <skycon :condition="hour.icon" :width="50" :height="50" />
                <p class="lead">{{ hour.time | moment("h a") }}</p>
                <p><strong>{{ hour.temperature | toInteger }}°F</strong></p>
              </div>
            </div><!-- /.row -->
            <!-- <div class="row">
              <div
                v-for="(day, index) in weather.data.message.daily.data"
                v-if="index > 0"
                class="col week-days"
              >
                <skycon :condition="day.icon" :width="50" :height="50" />
                <p>{{ day.time | moment("dddd") }}</p>
                <p>{{ day.temperatureMax | toInteger }} / {{ day.temperatureMin | toInteger }}°F</p>
              </div>
            </div> -->
            <!-- /.row -->
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-12 -->
    </div>
  </div><!-- /#weather -->
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        weather: {},
        extendedHours: false
      }
    },
    computed: {
      ...mapState(['dashboard'])
    },
    mounted() {
      this.getWeather()
    },
    methods: {
      getWeather() {
        let self = this
        setTimeout(function() {
          let timeStamp = new Date().getTime()
          let lng = self.dashboard.data.modules.weather.lng
          let lat = self.dashboard.data.modules.weather.lat
          axios
            .get('https://us-central1-hospitality-dashboard.cloudfunctions.net/getWeather?lng=' + lng + '&lat=' + lat + '&timestamp=' + timeStamp)
            .then(response => {
              self.weather = response
            })
        }, 1000)
      }
    },
    filters: {
      toInteger(value) {
        return value.toFixed(0)
      }
    }
  }
</script>

<style scoped>
  .card {
    background-color: #333;
    color: white;
  }
  .col-md-12, .col-md-2, .row, .card-body, .card-header, .col, #weather, p {
    margin-bottom: 0;
    padding: 0;
  }
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  .card-body {
    padding: 10px 10px 0 10px;
  }
  .week-days {
    border: 1px #333 solid;
    margin: 5px;
    padding: 5px;
    border-radius: 4px;
    background-color: white;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/tv/WeatherTV.vue